import { useContext } from 'react'
import { AppBar, IconButton } from '@mui/material'
import { CloseIcon } from '$common/icons/close'
import { BackButton } from '$common/buttons'
import { CircularLoading } from '$common/loading/circular-loading'
import { t } from '$i18n'
import { DirectionContext } from '$setup/root'
import { PageToolbar } from '$common/app-bar/common/page-toolbar'
import { AppBarSearchInput } from '$common/input/app-bar-search-input'

interface Prop {
  onBack: () => unknown
  setQuery: (query: string) => void
  loading?: boolean
  value: string
  height?: number
}

export function AppBarBackSearch({
  onBack,
  setQuery,
  loading,
  value,
  height,
}: Prop) {
  const direction = useContext(DirectionContext)

  return (
    <AppBar sx={{ maxWidth: 'none', margin: 0 }}>
      <PageToolbar sx={{ height }}>
        <BackButton onClick={onBack} />

        <AppBarSearchInput
          dir={direction}
          fullWidth
          autoFocus
          placeholder={t('common.search')}
          value={value}
          // value={'جستجو...'}
          onChange={e => setQuery(e.target.value)}
        />

        {value &&
          (loading ? (
            <CircularLoading size={20} />
          ) : (
            <IconButton onClick={() => setQuery('')}>
              <CloseIcon sx={{ color: 'neutral900' }} />
            </IconButton>
          ))}
      </PageToolbar>
    </AppBar>
  )
}
AppBarBackSearch.defaultProps = {
  loading: false,
}
